module.exports = __webpack_public_path__ + "static/media/3XL.60efe4de.jpg";